import { render, staticRenderFns } from "./ExplanatoryNoteAddTable.vue?vue&type=template&id=1033148f&"
import script from "./ExplanatoryNoteAddTable.vue?vue&type=script&lang=js&"
export * from "./ExplanatoryNoteAddTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports